import { useTranslation } from "@opendash/core";
import { Descriptions, DescriptionsProps, Tag } from "antd";
import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import {
  StepFieldType,
  StepsObjectInScheduleExecution,
  useMetaFields,
} from "..";

export const StepDescription = observer(
  (props: { step: StepsObjectInScheduleExecution }) => {
    const t = useTranslation();
    const [items, setItems] = useState<DescriptionsProps["items"]>([]);
    const { getTagValue, stepFieldHasValue } = useMetaFields(
      props.step.fields as StepFieldType[]
    );

    const descfields = [];

    // Nur Rollen hinzufügen, wenn sie existieren
    if (props.step.roles && props.step.roles.length > 0) {
      descfields.push({
        key: "roles",
        label: "Rollen",
        children: (
          <>
            {props.step.roles.map((role) => (
              <Tag color="processing" key={role.id}>
                {role.get("label") ? role.get("label") : role.get("name")}
              </Tag>
            ))}
          </>
        ),
      });
    }

    useEffect(() => {
      //Get all meta fields from step and set them in items
      const configfields = props.step.fields
        .filter(stepFieldHasValue)
        .map(async (result) => {
          const descitems = await Promise.all(getTagValue(result));

          return {
            key: result.metafield.label,
            label: result.metafield.label,
            children: (
              <>
                {descitems.length > 0 && descitems[0].length > 0
                  ? descitems.join(" - ")
                  : "-"}
              </>
            ),
          };
        });

      Promise.all(configfields).then((configfields) => {
        setItems([...descfields, ...configfields]);
      });
    }, [props.step]);

    return <Descriptions title={props.step.description} items={items} />;
  }
);
